import React from 'react';
import { Flex } from '@zillow/constellation';

export const ResultsSummary: React.FC<{
  pageSize: number;
  pageNumber: number;
  totalElements: number;
}> = ({ pageSize, pageNumber, totalElements }) => {
  const startResult = (pageNumber - 1) * pageSize + 1;
  const endResult = Math.min(pageNumber * pageSize, totalElements);

  return (
    <Flex display="flex" justifyContent="center" paddingY="sm">
      <span className="text-sm font-normal text-gray-700">
        Showing {startResult} to {endResult} of {totalElements} results
      </span>
    </Flex>
  );
};
